import { downloadInvoice as downloadInvoiceRequest } from '@app/services/documentsRepository';
import * as Sentry from '@sentry/react';
import { Id } from '@typings/@centra';
import { saveAs } from 'file-saver';
import React from 'react';
import { useDispatch } from 'react-redux';

interface DownloadInvoicePayload {
  invoiceId: Id;
  invoiceHash: Id;
  invoiceNumber: string;
}

export const useInvoiceDownload = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);

  const downloadInvoice = React.useCallback(
    async (payload: DownloadInvoicePayload) => {
      const { invoiceNumber, invoiceId, invoiceHash } = payload;
      setHasError(false);
      setIsLoading(true);
      try {
        const response = await downloadInvoiceRequest({ invoiceHash, invoiceId });
        saveAs(response.data as Blob, `invoice_${invoiceNumber}.${(response.data as Blob).type.split('/')[1]}`);
      } catch (error) {
        Sentry.captureException(error);
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch],
  );

  return {
    downloadInvoice,
    hasError,
    isLoading,
  };
};
